/**
 * Équilibrage par lignée : multiplicateur de PV et d’ATK appliqué à tous ses stades.
 * Généré par simulation (milliers de combats 3 contre 3 à coût égal) pour ramener
 * chaque lignée vers ~50% de victoires dans sa tranche de coût.
 */
export const BALANCE = {
  abra: 0.918,
  absol: 0.854,
  aerodactyl: 0.857,
  amaura: 0.89,
  anorith: 1.032,
  applin: 1.03,
  arceus: 1.032,
  archen: 1.029,
  aron: 1.08,
  axew: 1.317,
  azelf: 0.838,
  azurill: 1.061,
  bagon: 0.864,
  beldum: 1.043,
  bellibolt: 1.076,
  bergmite: 1.041,
  bidoof: 1.124,
  binacle: 0.979,
  blipbug: 1.3,
  blitzle: 0.97,
  bombirdier: 0.829,
  bounsweet: 0.961,
  bronzor: 1.132,
  buizel: 1.158,
  bulbasaur: 0.951,
  buneary: 1.05,
  buzzwole: 0.851,
  calyrex: 0.913,
  capsakid: 0.932,
  carvanha: 1.064,
  caterpie: 1.036,
  celebi: 1.236,
  cetoddle: 1.028,
  charmander: 0.969,
  chatot: 1.202,
  chespin: 0.956,
  'chi-yu': 0.675,
  'chien-pao': 0.865,
  chimchar: 1.084,
  chinchou: 1.043,
  chingling: 1.209,
  clamperl: 1.106,
  clauncher: 0.941,
  clefairy: 1.086,
  clodsire: 0.958,
  cobalion: 0.922,
  combee: 1.062,
  'corsola-g': 1.215,
  crabrawler: 1.109,
  cranidos: 1.045,
  croagunk: 0.979,
  cubchoo: 1.056,
  cubone: 1.105,
  cufant: 0.937,
  cynda: 0.92,
  deino: 1.071,
  deoxys: 0.85,
  dewpider: 1.075,
  dialga: 0.826,
  diancie: 1.322,
  drampa: 0.815,
  dreepy: 1.054,
  drifloon: 1.044,
  drowzee: 1.165,
  ducklett: 1.06,
  dunsparce: 1.119,
  duraludon: 0.837,
  duskull: 0.978,
  eevee: 0.929,
  ekans: 0.941,
  electrike: 0.947,
  elgyem: 1.031,
  entei: 1.023,
  espurr: 0.95,
  exegg: 0.944,
  falinks: 0.912,
  'farfetchd-g': 0.972,
  fennekin: 0.777,
  fezandipiti: 0.827,
  fidough: 1.112,
  flabebe: 0.777,
  flamigo: 0.957,
  fletch: 1.239,
  'flutter-mane': 0.637,
  frigibax: 1.059,
  froakie: 0.761,
  fuecoco: 1.121,
  furfrou: 0.927,
  gastly: 0.836,
  genesect: 0.87,
  gholdengo: 0.794,
  girafarig: 0.858,
  giratina: 0.932,
  gligar: 1.14,
  glimmet: 0.881,
  golett: 1.087,
  goomy: 1.098,
  'great-tusk': 0.736,
  greavard: 0.845,
  'grimer-a': 1.081,
  grookey: 0.979,
  growlithe: 0.838,
  grubbin: 1.227,
  happiny: 0.901,
  hatenna: 1.232,
  hawlucha: 0.942,
  heatran: 0.952,
  helioptile: 0.889,
  'ho-oh': 0.885,
  honedge: 1.038,
  hoopa: 0.852,
  hoothoot: 1.166,
  hoppip: 0.945,
  horsea: 1.115,
  igglybuff: 1.274,
  impidimp: 1.174,
  indeedee: 0.818,
  inkay: 1.044,
  'iron-bundle': 0.754,
  'iron-jugulis': 0.777,
  'iron-leaves': 0.774,
  'iron-moth': 0.6,
  'iron-treads': 0.816,
  ironval: 0.798,
  jangmo: 1.175,
  jirachi: 1.175,
  kabuto: 0.952,
  karrablast: 1.122,
  kartana: 0.894,
  keldeo: 1.029,
  klefki: 0.973,
  klink: 1.132,
  koffing: 0.932,
  koraidon: 0.823,
  krabby: 1.071,
  kricketot: 1.141,
  kubfu: 0.883,
  kyogre: 0.834,
  kyurem: 0.823,
  lapras: 0.974,
  larvesta: 0.91,
  larvitar: 1.129,
  latias: 0.835,
  latios: 0.825,
  lechonk: 0.943,
  lickitung: 1.021,
  lileep: 1.021,
  lilligant: 1.087,
  lillipup: 1.109,
  litten: 0.911,
  litwick: 0.933,
  lotad: 1.027,
  lunala: 1.346,
  machop: 1.092,
  magby: 0.893,
  magikarp: 0.782,
  magnemite: 1.096,
  mankey: 1.03,
  mareanie: 0.952,
  mareep: 1.238,
  marshadow: 1.049,
  maschiff: 0.855,
  mawile: 0.912,
  meditite: 1.03,
  meloetta: 0.75,
  meltan: 0.859,
  'meowth-g': 0.964,
  mesprit: 0.798,
  mew: 1.174,
  mewtwo: 0.955,
  mienfoo: 1.132,
  milcery: 1.04,
  mimikyu: 0.888,
  minccino: 0.933,
  miraidon: 0.902,
  misdreavus: 1.072,
  moltres: 0.708,
  morpeko: 1.02,
  mudbray: 0.949,
  mudkip: 1.142,
  munchlax: 0.902,
  munkidori: 0.76,
  munna: 1.03,
  nacli: 1.185,
  natu: 1.098,
  necrozma: 0.929,
  nickit: 1.122,
  nido: 1.229,
  nihilego: 0.602,
  nincada: 0.85,
  noibat: 0.884,
  numel: 1.055,
  nymble: 1.066,
  oddish: 0.927,
  okidogi: 0.882,
  onix: 0.913,
  oranguru: 0.969,
  oricorio: 0.773,
  oshawott: 0.968,
  pachirisu: 1.178,
  palkia: 0.74,
  pansage: 0.909,
  passimian: 0.938,
  pawmi: 1.133,
  pawniard: 1.038,
  pecharunt: 0.903,
  phanpy: 0.939,
  phantump: 0.75,
  pheromosa: 0.979,
  pidgey: 1.34,
  pidove: 1.173,
  piplup: 1.094,
  poipole: 0.95,
  ponyta: 1.034,
  poochyena: 0.949,
  popplio: 1.06,
  porygon: 1.04,
  psyduck: 1.153,
  pumpkaboo: 0.836,
  quaxly: 1.101,
  raichu: 1.098,
  raikou: 0.832,
  ralts: 0.905,
  rattata: 1.177,
  rayquaza: 0.851,
  regigigas: 0.872,
  regirock: 0.91,
  registeel: 0.87,
  reshiram: 0.72,
  rhyhorn: 1.14,
  riolu: 0.911,
  roaring: 0.846,
  rockruff: 1.092,
  roggenrola: 1.116,
  rolycoly: 1.049,
  rookidee: 1.272,
  roserade: 0.933,
  rowlet: 0.966,
  rufflet: 1.02,
  sableye: 0.86,
  salandit: 1.068,
  sand: 1.068,
  sandile: 0.838,
  'sandy-shocks': 0.808,
  sandygast: 0.918,
  scorbunny: 1.131,
  'scream-tail': 0.72,
  scyther: 0.898,
  seel: 1.233,
  sentret: 1.235,
  sewaddle: 1.17,
  shaymin: 1.139,
  shellder: 1.051,
  shellos: 1.042,
  shieldon: 1.042,
  shinx: 0.96,
  shuckle: 1.4,
  shuppet: 1.06,
  sizzlipede: 0.916,
  skorupi: 0.979,
  skrelp: 1.02,
  skwovet: 0.873,
  slakoth: 0.887,
  'slither-wing': 0.823,
  slowpoke: 1.065,
  smoliv: 0.71,
  sneasel: 0.931,
  snivy: 1.023,
  snorunt: 0.857,
  snover: 0.946,
  snubbull: 0.865,
  sobble: 0.899,
  solosis: 1.189,
  spheal: 1.219,
  sprigatito: 1.078,
  stantler: 0.861,
  starly: 1.055,
  staryu: 1.086,
  stonjourner: 0.825,
  stufful: 0.87,
  suicune: 0.938,
  swinub: 1.116,
  taillow: 1.043,
  tandemaus: 1.101,
  tangela: 1.047,
  'tapu-bulu': 0.896,
  'tapu-fini': 1.148,
  'tapu-lele': 0.858,
  tarountula: 1.064,
  tatsugiri: 0.872,
  tauros: 0.954,
  tentacool: 0.894,
  tepig: 0.879,
  terrakion: 1.106,
  thundurus: 0.823,
  timburr: 1.245,
  'ting-lu': 0.841,
  tinkatink: 1.123,
  tirtouga: 1.061,
  toedscool: 1.087,
  togepi: 1.245,
  torchic: 1.094,
  tornadus: 0.871,
  totodile: 1.083,
  toxel: 0.856,
  trapinch: 1.126,
  treecko: 0.854,
  turtwig: 0.888,
  tynamo: 1.219,
  tyrogue: 0.945,
  vanillite: 0.94,
  venipede: 1.24,
  victini: 0.976,
  virizion: 0.95,
  vivillon: 1.24,
  volcanion: 0.715,
  vullaby: 0.962,
  vulpix: 1.156,
  'vulpix-a': 0.845,
  'walking-wake': 0.688,
  wattrel: 0.946,
  weedle: 1.101,
  whismur: 1.039,
  wimpod: 0.9,
  'wo-chien': 0.909,
  wooloo: 0.896,
  wurmple: 1.314,
  xerneas: 0.824,
  xurkitree: 0.869,
  'yamask-g': 1.155,
  yanma: 1.111,
  yungoos: 1.127,
  yveltal: 0.956,
  zacian: 0.868,
  zamazenta: 0.842,
  zarude: 1.13,
  zekrom: 0.934,
  zeraora: 0.946,
  'zigzagoon-g': 1.24,
  zorua: 0.874,
  'zorua-h': 0.787,
  zubat: 1.215,
  zygarde: 0.833
};
